module.exports = __webpack_public_path__ + "static/media/sambridge-logo.d1d8e560.png";